import { createRequest, getEndpoint } from "../requestCreator";

export const createSpeechToken = createRequest(getEndpoint("chats.sub.createSpeechToken"));
export const streamMessages = createRequest(getEndpoint("chats.sub.streamMessages"));
export const createDocument = createRequest(getEndpoint("chats.sub.sub.sub.createDocument"));
export const deleteDocument = createRequest(getEndpoint("chats.sub.sub.sub.deleteDocument"));
export const getChatSettings = createRequest(getEndpoint("chats.sub.settings"));
